require('./organizationMenu.tpl.html');
require('./organizationMenuController.js');

const OrganizationMenuComponent = {
    templateUrl: '/configuration/organizationBrowser/menu/organizationMenu.tpl.html',
    controller: 'organizationMenuController',
    bindings: {
        organizationId: '<',
        defaultSelectedValue: '<',
        onSelectedItemChange: '&',
        onMenuHasSingleItem: '&',
        onMenuHasMultipleItems: '&'
    }
};

angular.module('ums.configuration')
    .component('uiOrganizationMenu', OrganizationMenuComponent);
